export default "__VITE_ASSET__Cj_N0Ryo__"